<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="infoSoForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24" nzLg="20" nzXl="21">
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="educationAndTrainingCode" nzSpan="24" nzRequired>Mã trung tâm</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="educationAndTrainingCode" type="text" placeholder="Nhập mã trung tâm" [jAutofocus] readonly>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="educationAndTrainingName" nzSpan="24"  nzRequired>Tên trung tâm GDĐB</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="educationAndTrainingName" type="text" placeholder="Nhập tên trung tâm">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">

        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="provinceId" nzSpan="24" nzRequired>Tỉnh thành</nz-form-label>
            <nz-form-control  nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)" formControlName="provinceId"
              [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn"></asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="districtId" nzSpan="24" nzRequired>Quận huyện</nz-form-label>
            <nz-form-control  nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <asc-autocomplete [ascModel]="districtControl" (ascModelChange)="changeDistrict($event)" formControlName="districtId"
              [placeholder]="'Chọn quận huyện'" [getListAC]="getDistrictACFn"></asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="wardId" nzSpan="24">Phường xã</nz-form-label>
            <nz-form-control  nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <asc-autocomplete [ascModel]="wardControl" (ascModelChange)="changeWard($event)" formControlName="wardId"
              [placeholder]="'Chọn phường xã'" [getListAC]="getWardACFn"></asc-autocomplete>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="villageName" nzSpan="24" >Thôn ấp</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="villageName" type="text" placeholder="Nhập thôn">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="address" nzSpan="24" nzRequired>Địa chỉ</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="address" type="text" placeholder="Nhập địa chỉ">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="phoneNumber" nzSpan="24" nzRequired>Số điện thoại</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="phoneNumber" type="text" placeholder="Nhập số điện thoại">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="email" nzSpan="24" >Email</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="email" type="text" placeholder="Nhập email">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="website" nzSpan="24" >Website</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="website" type="text" placeholder="Nhập website">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="fax" nzSpan="24" >Fax</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="fax" type="text" placeholder="Nhập fax">
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <nz-divider nzText="Thông tin giám đốc trung tâm GDĐB" nzOrientation="left" nzPlain></nz-divider>
      <div nz-row nzGutter="24">

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="director" nzSpan="24" >Tên GĐ</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="director" type="text" placeholder="Nhập tên GĐ">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="directorPhoneNumber" nzSpan="24" >Điện thoại GĐ</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="directorPhoneNumber" type="text" placeholder="Nhập sđt">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="directorEmail" nzSpan="24" >Email GĐ</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="directorEmail" type="text" placeholder="Nhập email">
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <nz-divider nzText="Thông tin tài khoản đăng nhập" nzOrientation="left" nzPlain></nz-divider>
      <div nz-row nzGutter="24">

        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="username" nzSpan="24" nzRequired>Tên đăng nhập</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="username" type="text" placeholder="Nhập tên đăng nhập">
            </nz-form-control>
          </nz-form-item>
        </div>

     
        <div nz-col nzSpan="8"></div> 
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label #label nzFor="isActive" nzSpan="24">Hoạt động:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group  formControlName="isActive">
              <label nz-radio [nzValue]="true">Có</label>
              <label nz-radio [nzValue]="false">Không</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

    </div>
  </div>
  <div *nzModalFooter> 
        <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button> 
  </div>
</form>